export default __webpack_public_path__ + "static/media/CBS-Excel-Icon.965bde9b.svg";